import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
export function MobileCTABar() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-40 flex gap-3 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]" data-id="element-106">
      <a href="tel:0232052161" className="flex-[2] bg-gold text-white py-3 px-4 rounded-brand font-semibold flex items-center justify-center shadow-sm active:bg-gold-dark transition-colors" data-id="element-107">
        <PhoneIcon className="w-5 h-5 mr-2" data-id="element-108" />
        Bel direct
      </a>
      <a href="https://wa.me/31612345678" target="_blank" rel="noopener noreferrer" className="flex-1 bg-[#25D366] text-white py-3 px-4 rounded-brand font-semibold flex items-center justify-center shadow-sm active:bg-[#1da851] transition-colors" data-id="element-109">
        <WhatsAppIcon className="w-6 h-6" data-id="element-110" />
      </a>
    </div>;
}